import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import DialogTitle from "@mui/material/DialogTitle";
import { DARK_THEME_BODY_COLOR } from "../../constants";

const ThemedDialogTitle = ({ id, sx, children }) => {
  const darkThemeEnabled = useSelector((state) => state.darkThemeEnabled);

  return (
    <DialogTitle
      id={id}
      sx={{
        ...sx,
        backgroundColor: darkThemeEnabled ? DARK_THEME_BODY_COLOR : "#f7f7f7",
      }}
    >
      {children}
    </DialogTitle>
  );
};

export default ThemedDialogTitle;
